import React from 'react';

import { Container, Skeleton } from '@mui/material';

import BackArrow from '../../../components/Atoms/BackArrow/BackArrow';
import Text from '../../../components/Atoms/Text/Text';
import Title from '../../../components/Atoms/Title/Title';
import AppTemplate from '../../../components/Templates/App/App';
import LoadingAppTemplate from '../../../components/Templates/LoadingApp/LoadingApp';

interface ICertificationLoadingSkeleton {
  withRealNavBar?: boolean;
}

const CertificationLoadingSkeleton = ({
  withRealNavBar,
}: ICertificationLoadingSkeleton): JSX.Element => {
  const Content = (): JSX.Element => {
    return (
      <Container maxWidth="sm">
        <BackArrow disabled={true} />

        <Title
          text={<Skeleton variant="text" width={'55%'} height={24} />}
          type="primary"
        />
        <Text
          text={
            <>
              <Skeleton variant="text" width={'100%'} height={18} />
              <Skeleton variant="text" width={'100%'} height={18} />
              <Skeleton variant="text" width={'60%'} height={18} />
            </>
          }
        />
        <Container maxWidth="sm">
          <div className="skeleton-center">
            <Skeleton variant="rectangular" width={'100%'} height={135} />
            <Skeleton variant="rectangular" width={'100%'} height={135} />
            <Skeleton variant="rectangular" width={'100%'} height={135} />
            <Skeleton variant="rectangular" width={'100%'} height={135} />
            <Skeleton variant="rectangular" width={'100%'} height={135} />
          </div>
        </Container>
      </Container>
    );
  };

  return (
    <>
      {withRealNavBar ? (
        <AppTemplate>
          <Content />
        </AppTemplate>
      ) : (
        <LoadingAppTemplate>
          <Content />
        </LoadingAppTemplate>
      )}
    </>
  );
};

export default CertificationLoadingSkeleton;
